import emptyIcon from '/asset/empty.jpg';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
export default function EmptyCart() {
  const navigate = useNavigate();
  const { routesPrefix } = useSelector((state: RootState) => state.setup);

  return (
    <div className="w-full py-[50px] bg-white">
      <div className="w-[300px] h-[300px] bg-primary-100 m-auto">
        <img src={emptyIcon} className="w-full h-full" />
      </div>
      <div className="w-[300px] h-[150px] m-auto">
        <div className="font-dmsans text-center text-primary-950 font-bold text-[20px]">
          Your cart is empty
        </div>
        <div className="font-dmsans text-center  text-primary-950 py-[10px] text-[12px]">
          Looks like you haven't made your choice yet...
        </div>
        <div
          className="w-full h-[50px] rounded-xl 
          bg-secondary-500 
          hover:bg-secondary-700 
          font-bold  cursor-pointer
          mt-[10px] text-white text-center p-[10px]"
          onClick={() => navigate(`${routesPrefix}`)}
        >
          Go to storefront
        </div>
      </div>
    </div>
  );
}
